// src/sections/admin/KiosksSection.js
import React, { useState } from 'react';
import axios from 'axios';
import ResourceTable from '../../components/admin/ResourceTable';
import KioskForm from '../../components/admin/KioskForm';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const KiosksSection = ({ user, kiosks = [], setMsg, fetchAll }) => {
  const [showForm, setShowForm] = useState(false);
  const [editingKiosk, setEditingKiosk] = useState(null);

  const adminTenantId = user?.tenant_id != null ? parseInt(user.tenant_id, 10) : null; 

  const kioskColumns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Kiosk Name' },
    { key: 'printer_ip', label: 'Printer IP' },
    { key: 'tenant_id', label: 'Tenant ID' }
  ];

  const handleAddKiosk = () => {
    setEditingKiosk(null); 
    setShowForm(true);
  };

  const handleEditKiosk = (kioskData) => {
    setEditingKiosk(kioskData);
    setShowForm(true);
  };

  const handleDeleteKiosk = async (kioskData) => {
    if (window.confirm(`Are you sure you want to delete kiosk ${kioskData.name}?`)) {
      try {
        await axios.delete(`${BASE_URL}/api/kiosks/${kioskData.id}`);
        setMsg({ type: 'success', text: `Kiosk ${kioskData.name} deleted successfully!` });
        fetchAll(); 
      } catch (error) {
        setMsg({ type: 'error', text: `Failed to delete kiosk: ${error.message}` });
        console.error("Error deleting kiosk:", error);
      }
    }
  };

  const handleSubmitKioskForm = async (formData, isEditMode) => {
    try {
      const dataToSubmit = { ...formData };
      if (isEditMode) {
        await axios.patch(`${BASE_URL}/api/kiosks/${formData.id}`, dataToSubmit);
        setMsg({ type: 'success', text: `Kiosk ${formData.name} updated successfully!` });
      } else {
        dataToSubmit.tenant_id = adminTenantId;
        await axios.post(`${BASE_URL}/api/kiosks`, dataToSubmit);
        setMsg({ type: 'success', text: `Kiosk ${formData.name} added successfully!` });
      }
      setShowForm(false);
      setEditingKiosk(null);
      fetchAll();
    } catch (error) {
      setMsg({ type: 'error', text: `Failed to ${isEditMode ? 'update' : 'add'} kiosk: ${error.message}` });
      console.error("Error submitting kiosk form:", error);
    }
  };

  let filteredKiosks = kiosks;
  if (user?.role === 'admin') {
    filteredKiosks = kiosks.filter(k => String(k.tenant_id) === String(adminTenantId));
  } else if (user?.role === 'vendor_admin' || String(user?.tenant_id) === '999') {
    filteredKiosks = kiosks;
  }

  return (
    <div>
      <h2 className="admin-section-header">Kiosk Management</h2>
      {!showForm ? (
        <>
          <button onClick={handleAddKiosk} className="admin-button primary" style={{ marginBottom: '1.5rem' }}>Add New Kiosk</button>
          <ResourceTable 
            data={filteredKiosks} 
            columns={kioskColumns} 
            onEdit={handleEditKiosk} 
            onDelete={handleDeleteKiosk} 
            title="Kiosks"
          />
        </>
      ) : (
        <KioskForm 
          user={user} 
          initialData={editingKiosk || {}} 
          onSubmit={handleSubmitKioskForm} 
          onCancel={() => setShowForm(false)} 
        />
      )}
    </div>
  );
};

export default KiosksSection;